module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 1423
// module chunks = 69